// ==============================================
// ===================Imports====================
// ==============================================
// ==============================================

// =================ACTIONS=====================
import { SET_OPEN_COOKIE_POPUP } from '../actions/popupCookie';

// ==============================================
// ================InitialState==================
// ==============================================

const initialState = {
  openCookiePopup: true,
};

function popupCookieReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_OPEN_COOKIE_POPUP:
      return {
        ...state,
        openCookiePopup: action.value,
      };
    default:
      return state;
  }
}

export default popupCookieReducer;
